module.exports = __webpack_public_path__ + "static/img/Homev1.b13dd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/Homev1.png
// module id = 1RwD
// module chunks = 36